import { __extends } from "tslib";
import React, { PureComponent } from 'react';
import { renderPopoverContent } from '../ExceedStandardRiskForField';
import styles from './NoteView.module.less';
import { app as api } from '@ekuaibao/whispered';
import { get } from 'lodash';
import NoteContentLine from './NoteContentLine';
import classNames from 'classnames';
import { isIE } from '../../../lib/misc';
import { OutlinedEditDeleteTrash } from '@hose/eui-icons';
var NoteView = (function (_super) {
    __extends(NoteView, _super);
    function NoteView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleAddNote = function () {
            var _a = _this.props, flowId = _a.flowId, detailId = _a.detailId, isDetail = _a.isDetail, field = _a.field;
            api.open('@bills:NoteEditModal', { page: 'add', flowId: flowId, detailId: detailId, isDetail: isDetail, field: field });
        };
        _this.handleChangePageToDelete = function (noteId) {
            var flowId = _this.props.flowId;
            api.open('@bills:NoteEditModal', { page: 'delete', flowId: flowId, noteId: noteId });
        };
        _this.renderNoteByType = function (noteType) {
            var _a = _this.props, noteArr = _a.noteArr, detailReadable = _a.detailReadable, canEditNote = _a.canEditNote, authorRemovable = _a.authorRemovable, showBillNotesInHistory = _a.showBillNotesInHistory, field = _a.field;
            var singleNoteArr = noteArr.filter(function (el) { return el.type === noteType; });
            if (!singleNoteArr.length)
                return null;
            var canDeleteNote = !showBillNotesInHistory && canEditNote && (authorRemovable || noteType === 'NORMAL');
            console.log("[ \u7CFB\u7EDF\u914D\u7F6E\u662F\u5426\u8BA9\u7F16\u8F91 ] >: canDeleteNote: " + canDeleteNote + "\n    !showBillNotesInHistory: " + !showBillNotesInHistory + "\n    canEditNote: " + canEditNote + "\n    (authorRemovable || noteType === 'NORMAL'): " + (authorRemovable || noteType === 'NORMAL') + "\n    authorRemovable: " + authorRemovable + "\n    noteType: " + noteType + "\n    ");
            return (React.createElement("div", { className: 'note-item' },
                field !== 'Credit-Note-Pop' && React.createElement("div", { className: 'note-type' }, noteType === 'NORMAL' ? i18n.get('普通批注') : i18n.get('信用批注')),
                singleNoteArr.map(function (note, idx) {
                    var content = note.content, authorName = note.authorName, rule = note.rule, authorId = note.authorId;
                    var name = i18n.get("{__k0}", { __k0: authorName });
                    var staffId = api.getState('@common.userinfo.staff.id');
                    console.log(canDeleteNote, '[ 系统配置的 canDeleteNote  true 才对比 用户信息 ] >');
                    var isShowDelete = canDeleteNote;
                    if (canDeleteNote) {
                        isShowDelete = authorId === staffId;
                        console.log("[ authorId === staffId ] >: isShowDelete: " + isShowDelete + "\n          " + authorId + " " + (isShowDelete ? '同一个人' : "不同一个人") + " " + staffId + "\n          ");
                    }
                    var text;
                    if (noteType === 'NORMAL') {
                        text = React.createElement(NoteContentLine, { name: name, text: content });
                    }
                    else {
                        var permissions = api.getState('@common.userinfo.permissions') || [];
                        isShowDelete = isShowDelete || !!~(permissions === null || permissions === void 0 ? void 0 : permissions.indexOf('CREDIT_MANAGE'));
                        console.log("[ permissions isShowDelete ] >: isShowDelete: " + isShowDelete + "\n          \u7528\u6237\u6743\u9650permissions: " + permissions + "\n          !!~permissions?.indexOf('CREDIT_MANAGE'): " + !!~(permissions === null || permissions === void 0 ? void 0 : permissions.indexOf('CREDIT_MANAGE')) + "\n          ");
                        text = React.createElement(NoteContentLine, { name: name, text: content });
                        if (detailReadable) {
                            var label = get(rule, 'label');
                            var score = get(rule, 'score', '');
                            text = React.createElement(NoteContentLine, { name: name, text: label, score: score });
                        }
                    }
                    console.log('[最后展示: isShowDelete ] >', isShowDelete);
                    return (React.createElement("div", { className: classNames("note-content", { "jc-sb": !isIE(), "option-line": !isIE(), 'pos-r': isIE() }), key: idx },
                        text,
                        isShowDelete && (React.createElement("div", { className: classNames('note-delete-btn-wrap', { 'ie-note-delete-btn-wrap': isIE() }), onClick: function () { return _this.handleChangePageToDelete(note.id); } },
                            React.createElement(OutlinedEditDeleteTrash, { fontSize: 14, className: 'note-delete-btn' })))));
                })));
        };
        _this.renderRiskContent = function () {
            var _a = _this.props, external = _a.external, field = _a.field;
            if (field === 'Credit-Note-Pop' || !external)
                return null;
            return (React.createElement("div", { className: 'note-item' }, renderPopoverContent(external)));
        };
        _this.renderContent = function () {
            var field = _this.props.field;
            return (React.createElement("div", { className: classNames('note-content-wrap', { 'note-content-wrap-layout': !isIE() }) },
                field !== 'Credit-Note-Pop' && _this.renderNoteByType('NORMAL'),
                _this.renderNoteByType('CREDIT')));
        };
        _this.renderBtn = function () {
            var _a = _this.props, canEditNote = _a.canEditNote, showBillNotesInHistory = _a.showBillNotesInHistory, field = _a.field;
            if (field === 'Credit-Note-Pop' || !canEditNote || showBillNotesInHistory)
                return null;
            return (React.createElement("div", { className: "note-btn-wrap" },
                React.createElement("div", { className: 'note-add-btn', onClick: _this.handleAddNote }, i18n.get('添加批注'))));
        };
        return _this;
    }
    NoteView.prototype.render = function () {
        return (React.createElement("div", { className: styles['noteView-wrap'] },
            this.renderContent(),
            this.renderBtn()));
    };
    return NoteView;
}(PureComponent));
export default NoteView;
